<template>
  <div class="offer-grid">
    <article
        class="offer-card"
        v-for="item in offerItems"
        :key="item.title"
    >
      <div class="offer-card__media">
        <img :src="item.image" :alt="item.imageAlt">
      </div>
      <div class="offer-card__content">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'OfferVue',
  data() {
    return {
      offerItems: [
        {
          title: 'System kalendarza',
          description: 'Dzięki tej funkcjonalności będziesz mógł/mogła prowadzić swój własny kalendarz, przez który Twoi klienci będą mogli umawiać się na wizyty.',
          image: new URL('@/assets/illustrations/business/offer-calendar.svg', import.meta.url).href,
          imageAlt: 'System kalendarza'
        },
        {
          title: 'Automatyczna płatność za zarezerwowaną wizytę',
          description: 'Możliwość ustawienia płatności w wysokości 50% lub 100% ceny wizyty — zależnie od potrzeb.',
          image: new URL('@/assets/illustrations/business/offer-payment.svg', import.meta.url).href,
          imageAlt: 'Automatyczna płatność'
        },
        {
          title: 'Powiadomienia',
          description: 'Informacje mailowe o zarezerwowanych i odwołanych wizytach.',
          image: new URL('@/assets/illustrations/business/offer-notifications.svg', import.meta.url).href,
          imageAlt: 'Powiadomienia'
        },
        {
          title: 'Własna wizytówka',
          description: 'Jako usługodawca możesz stworzyć własną wizytówkę z opisem, galerią, danymi kontaktowymi i czatem.',
          image: new URL('@/assets/illustrations/business/offer-profile.svg', import.meta.url).href,
          imageAlt: 'Własna wizytówka'
        },
        {
          title: 'Przejrzysty interfejs',
          description: 'Panel zarządzania kontem zaprojektowaliśmy intuicyjnie, aby szybko wykonywać niezbędne działania.',
          image: new URL('@/assets/illustrations/business/offer-interface.svg', import.meta.url).href,
          imageAlt: 'Przejrzysty interfejs'
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.offer-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.offer-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.offer-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.1);
  border-color: #a7f3d0;
}

.offer-card__media {
  height: 180px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfeff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.offer-card__media img {
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.offer-card__content {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.offer-card__content h3 {
  margin: 0;
  font-size: 2.1rem;
  line-height: 1.2;
  color: #111827;
}

.offer-card__content p {
  margin: 0;
  font-size: 1.45rem;
  line-height: 1.55;
  color: #6b7280;
}

@media (max-width: 1024px) {
  .offer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .offer-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .offer-card__media {
    height: 160px;
  }

  .offer-card__media img {
    max-height: 124px;
  }

  .offer-card__content {
    padding: 14px;
  }

  .offer-card__content h3 {
    font-size: 1.9rem;
  }

  .offer-card__content p {
    font-size: 1.35rem;
  }
}
</style>